import {FormGroup} from '@angular/forms';

export interface FormBuilderInterface {
  getForm(): FormGroup;
}
